import { createStore } from 'vuex'
import accountsStore from './Modules/Accounts/accountsStore.js'
import companyStore from './Modules/Company/companyStore.js'
import vendorStore from './Modules/Vendors/vendorStore.js'
import messagingStore from './Modules/Messaging/messagingStore.js'
import buyerStore from './Modules/Buyers/buyerStore.js'
import micrositeStore from './Modules/Microsite/micrositeStore.js'
import affiliatesStore from './Modules/Affiliates/affiliatesStore.js'
import landlordStore from './Modules/Landlords/landlordStore.js'
import tenantStore from './Modules/Tenants/tenantStore.js'
import prospectTenantStore from './Modules/Prospects/prospectTenantStore.js'
import paymentRequestsStore from './Modules/PaymentRequests/paymentRequestsStore.js'
import prospectGenericStore from './Modules/Prospects/prospectGenericStore.js'
import uploadsStore from './Modules/Uploads/uploadsStore.js'
import contractorStore from './Modules/Contractor/contractorStore.js'
import overridesStore from './Modules/Overrides/overridesStore.js'

export default createStore ({
    namespaced: true,
    state:{
    },
    mutations:{
    },
    actions:{

    },
    modules:{
        accountsStore,
        companyStore,
        vendorStore,
        messagingStore,
        buyerStore,
        micrositeStore,
        affiliatesStore,
        landlordStore,
        tenantStore,
        prospectTenantStore,
        paymentRequestsStore,
        prospectGenericStore,
        uploadsStore,
        contractorStore,
        overridesStore
    }
})